import { NotificationListFiltersTeamsDto } from '@dto/notification-list/notification-list-filters-teams.dto';
import { NotificationListDto } from '@dto/notification-list/notification-list.dto';
import { createAction, props } from '@ngrx/store';

const state = '[Notification List Teams]';

export const loadNotificationListTeams = createAction(
  `${state} Load notifications`,
  props<{
    currentPageNumber: number;
    filters: NotificationListFiltersTeamsDto;
    pageSize: number;
  }>()
);

export const loadNotificationListTeamsSuccess = createAction(
  `${state} Load notifications Success`,
  props<{ notificationList: NotificationListDto }>()
);

export const loadNotificationListTeamsFailure = createAction(
  `${state} Load notifications Failure`,
  props<{ error: string }>()
);
